<template>
	<v-flex class="d-flex align-center pa-0 mb-2">
		<h5 class="text-h5 primary--text text--lighten-5">More Pocket Games</h5>
		<v-spacer></v-spacer>
		<v-btn small text class="grey--text" v-if="$vuetify.breakpoint.mdAndUp"
			>See all
			<v-icon right> mdi-arrow-right </v-icon>
		</v-btn>
		<v-btn icon small color="grey" v-if="$vuetify.breakpoint.smAndDown">
			<v-icon right> mdi-arrow-right </v-icon>
		</v-btn>
	</v-flex>
</template>

<script>
export default {}
</script>

<style></style>
